import { useActivitiesContext } from '@user/features/Activity/context'
import {
  clearAllFiltersActionCreator,
  selectAllFiltersActionCreator,
} from '@user/features/Activity/state'

export function useHandlers() {
  const [, dispatch] = useActivitiesContext()

  function onHideAllClick() {
    dispatch(clearAllFiltersActionCreator())
  }

  function onShowAllClick() {
    dispatch(selectAllFiltersActionCreator())
  }

  return { onHideAllClick, onShowAllClick } as const
}
